import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {NgxSpinnerService} from 'ngx-spinner';
import {ToastrService} from 'ngx-toastr';
import {ApiService} from 'src/app/service/api.service';

@Component({
  selector: 'app-entrar',
  templateUrl: './entrar.component.html',
  styleUrls: ['./entrar.component.css']
})
export class EntrarComponent implements OnInit {
  var_l: any;
  var_q: any;
  var_r: any;
  var_v: any;
  var_a: any;
  var_vr: any;
  var_owlCar: any;


  modalRef: BsModalRef;
  modalProtocoloRef: BsModalRef;
  acesso: string = '';
  jsonArrayStatus: any;
  situacaopg: number = 0;
  datacertificado: string = '';

  formAvaliar: FormGroup;
  slideOneForm: FormGroup;
  formComentario: FormGroup;
  id: string;
  face: string;
  jsonArray: any;
  jsonArrayAvaliacao: any;
  jsonArrayLojista: any;
  jsonArrayValor: any;
  row_data: any;
  justificativa: string = '';
  justificarResposta: boolean = false;
  btnvoltar: boolean = false;
  btnfinal: boolean = false;
  oculto: boolean = false;
  contador: number = 0;
  loading: any;
  filtro: string;
  questao: string = 'ilustracao';
  segmentoid: string = '0';
  valorquestionario: string = '0';
  questionariovalor: number = 0;
  valornotassalvas: number = 0;
  observacao: boolean = false;
  alertaquestao: boolean = false;
  situacaoperfil: string = '';
  imgprot: string = '';
  tituloprot: string = '';
  descricaoprot: string = '';
  empresa: string;
  cnpj: string;
  estado: string;
  cidade: string;
  datavencimento: string;
  email: string;
  senhanova: string = '';
  senhaconfirmar: string = '';
  statusavaliacao: number = 0;
  latitude: string;
  longetude: string;
  jsonArrayEstados: any;
  jsonArrayCidades: any;
  jsonArraySegmento: any;
  jsonCidadeEstado: any;
  jsonArrayGPS: any;
  jsonValidar: any;

  config = {
    keyboard: false,
    backdrop: false,
    ignoreBackdropClick: true
  };

  configForm = {
    keyboard: false,
    backdrop: false,
    ignoreBackdropClick: true,
    class: 'gray modal-lg'
  };

  customOptions: any = {
    loop: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 1
      },
      940: {
        items: 1
      }
    },
    nav: false
  };

  constructor(private modalService: BsModalService, public formBuilder: FormBuilder, private apiService: ApiService,
              private spinner: NgxSpinnerService, private toastr: ToastrService, private router: Router) {
  }

  ngOnInit() {
    this.acesso = localStorage.getItem('acesso');
    this.id = localStorage.getItem('lojistaid');
    this.face = localStorage.getItem('lojistaid');

    if (this.acesso === 'true') {
      this.formAvaliar = this.formBuilder.group({
        idface: [this.face],
        lojistaid: [this.id],
        dadosavaliar: [''],
        valorquestionario: ['']
      });

      this.formComentario = this.formBuilder.group({
        lojistaid: [this.id],
        idface: [this.face],
        comentario: ['']
      });

      this.slideOneForm = this.formBuilder.group({
        idempresa: [''],
        empresa: ['', Validators.required],
        segmento: ['', Validators.required],
        estado: ['', Validators.required],
        cidade: ['', Validators.required],
        site: ['', Validators.required],
        cnpj: ['', Validators.required],
        endereco: ['', Validators.required],
        numero: ['', Validators.required],
        telefone: ['', Validators.required],
        nota: ['5'],
        responsavel: [''],
        lat: [''],
        lng: ['']
      });

      this.carregarLojista();
    } else {
      this.router.navigate(['/'], {replaceUrl: true});
    }

  }

  carregarLojista() {
    this.apiService.getListagemId('empresaavaliar', this.id)
      .subscribe(
        (data) => { //start of (1)

          this.jsonArrayLojista = data;

          for (var i = 0; i < this.jsonArrayLojista.length; i++) {
            this.id = this.jsonArrayLojista[i].lojistaid;
            this.empresa = this.jsonArrayLojista[i].nome;
            this.cnpj = this.jsonArrayLojista[i].cnpj;
            this.estado = this.jsonArrayLojista[i].estado;
            this.cidade = this.jsonArrayLojista[i].cidade + '-' + this.jsonArrayLojista[i].estado;
            this.email = this.jsonArrayLojista[i].site;
            this.datavencimento = this.jsonArrayLojista[i].datavencimento;
            this.statusavaliacao = parseInt(this.jsonArrayLojista[i].statuspagamento);
            this.latitude = this.jsonArrayLojista[i].latitude;
            this.longetude = this.jsonArrayLojista[i].longetude;
          }

          this.carregarEstados();

        }, //end of (1)
        (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

  carregarEstados() {
    this.apiService.getEstados()
      .subscribe(
        (data: any) => { //start of (1)

          this.jsonArrayEstados = data.data;

          this.carregarCidades();

        }, //end of (1)
        (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

  carregarCidades() {
    this.apiService.getCidades()
      .subscribe(
        (data: any) => { //start of (1)

          this.jsonArrayCidades = data.data;

          this.jsonCidadeEstado = [];
          for (var i = 0; i < this.jsonArrayCidades.length; i++) {
            if (this.jsonArrayCidades[i].uf === this.estado) {
              this.jsonCidadeEstado.push({cidade: this.jsonArrayCidades[i].cidade});
            }
          }

          this.carregarSegmento();

        }, //end of (1)
        (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

  carregarSegmento() {
    this.apiService.getListagem('segmentos')
      .subscribe(
        (data) => { //start of (1)

          this.jsonArraySegmento = data;

        }, //end of (1)
        (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

  abrirCadastro(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.configForm);
    /*this.modalRef = this.modalService.show(template, {
      backdrop : 'static',
      keyboard : false,
      class: 'gray modal-lg'
    });*/
    for (var i = 0; i < this.jsonArrayLojista.length; i++) {
      this.slideOneForm = this.formBuilder.group({
        idempresa: this.id,
        empresa: this.jsonArrayLojista[i].nome,
        segmento: this.jsonArrayLojista[i].segmentoid,
        estado: this.jsonArrayLojista[i].estado,
        cidade: this.jsonArrayLojista[i].cidade,
        site: this.jsonArrayLojista[i].site,
        cnpj: this.jsonArrayLojista[i].cnpj,
        endereco: this.jsonArrayLojista[i].endereco,
        numero: this.jsonArrayLojista[i].numero,
        telefone: this.jsonArrayLojista[i].telefone,
        nota: ['5'],
        responsavel: this.jsonArrayLojista[i].responsavel,
        lat: this.jsonArrayLojista[i].latitude,
        lng: this.jsonArrayLojista[i].longetude
      });
    }
  }

  protocoloAvaliar(template: TemplateRef<any>, item) {
    this.modalProtocoloRef = this.modalService.show(template, this.config);

    this.imgprot = item.imagem;
    this.tituloprot = item.questao;
    this.descricaoprot = item.descricaoimagem;
  }

  atestadoParticipacao() {
    var url = 'https://cvalesegtop.com.br/certificado/atestado.php?empresa=' + this.id;
    window.open(url, '_blank');
  }

  abrirRegulamento() {
    var url = 'https://cvalesegtop.com.br/regulamento/';
    window.open(url, '_blank');
  }

  avaliarLoja(alerta: TemplateRef<any>) {

    if (this.statusavaliacao === 2) {
      var url = 'https://cvalesegtop.com.br/certificado/auditada.php?empresa=' + this.id;
      window.open(url, '_blank');
    } else {
      this.modalProtocoloRef = this.modalService.show(alerta, this.config);
    }
    /*this.jsonArrayStatus = [];
    this.spinner.show();
    this.jsonArrayStatus = [];
    this.apiService.getListagemId('pagamentostatus', this.id)
      .subscribe(
        (data) => { //start of (1)

          this.jsonArrayStatus = data;

          this.spinner.hide();



          if (this.jsonArrayStatus.length > 0) {
            this.situacaopg = parseInt(this.jsonArrayStatus[0].status);
            this.datacertificado = this.jsonArrayStatus[0].datavencimento;

            if (this.situacaopg === 5) {
              this.modalProtocoloRef = this.modalService.show(alerta, this.config);
            } else if (this.situacaopg === 2) {
              this.modalProtocoloRef = this.modalService.show(alerta, this.config);
            } else if (this.situacaopg === 3) {
              this.modalProtocoloRef = this.modalService.show(alerta, this.config);
            } else if (this.situacaopg === 4) {
              //this.toastr.warning('Abrir certificdo!');
              window.open(url, '_blank');
            } else if (this.situacaopg === 1) {
              window.open(url, '_blank');
            } else {
              window.open(url, '_blank');
            }
          } else {
            window.open(url, '_blank');
          }

        }, //end of (1)
        (error: any) => {
          this.spinner.hide();
          console.log("ERRO 1: " + JSON.parse(JSON.stringify(error)))
        }
      );*/
  }

  autoAvaliacao(template) {
    this.spinner.show();
    this.jsonArray = [];
    this.jsonArrayValor = [];

    this.btnvoltar = false;
    this.btnfinal = false;
    this.contador = 0;

    this.apiService.getListagemId('questoesavaliar', this.id)
      .subscribe(
        (data) => { //start of (1)

          this.jsonArray = data;

          if (this.jsonArray.length > 0) {
            this.segmentoid = this.jsonArray[0].segmentoid;
            this.observacao = true;
            this.alertaquestao = false;
            this.carregarTotalNota(template);
          } else {
            this.spinner.hide();
            this.observacao = false;
            this.alertaquestao = true;
          }

        }, //end of (1)
        (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

  carregarTotalNota(template) {
    this.apiService.getListagemId('valorquestionario', this.segmentoid)
      .subscribe(
        (data) => { //start of (1)

          this.jsonArrayValor = data;

          this.valorquestionario = this.jsonArrayValor[0].valor;

          this.formAvaliar.setValue({
            idface: [this.face],
            lojistaid: [this.id],
            dadosavaliar: [''],
            valorquestionario: [this.valorquestionario]
          });

          this.spinner.hide();

          this.modalRef = this.modalService.show(template, this.config);

        }, //end of (1)
        (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

  sairApp() {
    localStorage.setItem('acesso', 'false');
    localStorage.setItem('lojistaid', 'null');
    this.router.navigate(['/'], {replaceUrl: true});
  }

  swipeNext(l, q, r, v, a, vr, owlCar) {
    this.var_l = l;
    this.var_q = q;
    this.var_r = r;
    this.var_v = v;
    this.var_a = a;
    this.var_vr = vr;
    this.var_owlCar = owlCar;

    this.justificarResposta = false;
    this.proximaQuestao(owlCar);
  }

  proximaQuestao(owlCar) {
    // + ' AND respostaid =' + r
    /*if (this.justificativa.length < 20) {
      this.toastr.warning('Justifique sua resposta! (minímo de 20 caracteres)', 'Atenção!');
    } else {

    }*/

    var valor = '0';
    var nota = '0';

    if (this.var_a === 'N') {
      valor = this.var_vr;
      nota = '0';
    } else {
      valor = '0';
      nota = this.var_v;
    }

    if (this.contador === this.jsonArray.length) {
      this.contador = this.jsonArray.length;
    } else {
      this.contador++;
    }

    if (this.contador === 0) {
      this.btnvoltar = false;
    } else {
      this.btnvoltar = true;
      if (this.contador === this.jsonArray.length) {
        this.btnfinal = true;
      } else {
        this.btnfinal = false;
      }
    }

    this.justificarResposta = false;
    owlCar.next();

    this.apiService.salvarRespostas('salvarresposta', this.var_l, this.var_q, this.var_r, this.var_v, this.var_a, valor, this.justificativa)
      .subscribe(
        (data) => { //start of (1)
          this.justificativa = '';
        }, //end of (1)
        (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );


  }

  swipePrev(lojistaid, questionarioid, owlCar) {
    setTimeout(() => {
      this.contador--;

      if (this.contador === 0) {
        this.btnvoltar = false;
      } else {
        this.btnvoltar = true;
        if (this.contador === this.jsonArray.length) {
          this.btnfinal = true;
        } else {
          this.btnfinal = false;
        }
      }

      this.justificativa = '';
      this.justificarResposta = false;
      owlCar.prev();

      this.apiService.cancelarRespostas('cancelarresposta', lojistaid, questionarioid)
        .subscribe(
          (data) => { //start of (1)

          }, //end of (1)
          (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
          () => console.log('all data gets') //(3) second argument
        );

    }, 250);
  }

  finalizarAvaliacao() {
    this.spinner.show();
    this.apiService.getListagemId('carregarnotasavaliar', this.id)
      .subscribe(
        (data) => { //start of (1)

          this.jsonArrayAvaliacao = data;

          var totaldesc = 0;

          for (var i = 0; i < this.jsonArrayAvaliacao.length; i++) {
            totaldesc += parseFloat(this.jsonArrayAvaliacao[i].valorabater);
            this.valornotassalvas += parseFloat(this.jsonArrayAvaliacao[i].notavalor);
          }

          this.questionariovalor = parseFloat(this.valorquestionario) - totaldesc;

          setTimeout(() => {
            this.salvarAvaliacaoCalculo();
          }, 500);

        }, //end of (1)
        (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

  salvarAvaliacaoCalculo() {

    var notafinal = (this.valornotassalvas / this.questionariovalor) * 100;

    console.log(notafinal);

    this.apiService.saveCadastroId('salvaravaliacaocalculo', this.id, notafinal.toFixed(0), this.id)
      .subscribe(
        (data) => { //start of (1)

          this.modalRef.hide();
          this.spinner.hide();

          this.abrirAvaliacao();

        }, //end of (1)
        (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

  abrirAvaliacao() {
    this.modalRef.hide();
    this.router.navigate(['/avaliacao', this.id], {replaceUrl: true});
  }

  alterarSenha(template: TemplateRef<any>) {
    this.modalRef.hide();
    this.senhanova = '';
    this.senhaconfirmar = '';
    this.modalRef = this.modalService.show(template, this.config);
  }

  salvarNovaSenha() {
    if (this.senhanova === '' || this.senhaconfirmar === '') {
      this.toastr.warning('Informe sua nova senha!', 'Atenção!');
    } else {
      if (this.senhaconfirmar === this.senhanova) {
        this.spinner.show();
        this.apiService.getListagemIds('trocarsenha', this.id, this.senhanova)
          .subscribe(
            (data) => { //start of (1)

              this.spinner.hide();
              this.modalRef.hide();
              this.toastr.success('Senha atualizada com sucesso!');

            }, //end of (1)
            (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
            () => console.log('all data gets') //(3) second argument
          );
      } else {
        this.toastr.warning('As senhas informadas não conferem!');
      }
    }
  }

  abrirManual() {
    window.open('https://cartoriotop.com.br/wp-content/uploads/2024/03/E-book-Cartorio-TOP-Versao-Final-2024-Rev01.pdf', '_blank');
  }

  carregarStatusPagamento(alerta: TemplateRef<any>) {
    this.spinner.show();
    this.jsonArrayStatus = [];
    this.apiService.getListagemId('pagamentostatus', this.id)
      .subscribe(
        (data) => { //start of (1)

          this.jsonArrayStatus = data;

          this.spinner.hide();

          if (this.jsonArrayStatus.length > 0) {
            this.situacaopg = this.jsonArrayStatus[0].status;
            this.datacertificado = this.jsonArrayStatus[0].datavencimento;

            this.solicitarSelo(alerta);
          } else {
            this.toastr.warning('Realize a autoavaliação para solicitar o Selo!');
          }

        }, //end of (1)
        (error: any) => {
          this.spinner.hide();
          this.toastr.warning('Realize a autoavaliação para solicitar o Selo!');
          console.log('ERRO 1: ' + JSON.parse(JSON.stringify(error)));
        }
      );
  }

  solicitarSelo(template) {

    console.log(this.situacaopg);

    if (this.situacaopg === 2) {
      this.toastr.warning('Aguarde a visita do auditor para a liberação do certificado!');
    } else if (this.situacaopg === 3) {
      this.modalProtocoloRef = this.modalService.show(template, this.config);
    } else if (this.situacaopg === 4) {
      window.open('https://ambienteseguro.app.br/certificado-pdf/auditada.php?empresa=' + this.id + '&data=' + this.datacertificado, '_blank');
    } else if (this.situacaopg === 1) {
      var url = 'https://ambienteseguro.app.br/selo/pagseguro.php?v=' + this.id;
      window.open(url, '_blank');
    } else if (this.situacaopg === 5) {
      this.modalProtocoloRef = this.modalService.show(template, this.config);
    } else {
      this.toastr.warning('Realize a autoavaliação para solicitar o Selo!');
    }
  }

  abrirContato() {
    var url = 'https://cvalesegtop.com.br/contato/';
    window.open(url, '_blank');
  }

  abrirAdesao() {
    var url = 'https://ambienteseguro.app.br/selo/pagseguro.php?v=' + this.id;
    window.open(url, '_blank');
  }

  adesaoSelo() {
    var url = 'https://ambienteseguro.app.br/selo/pagseguro.php?v=' + this.id;
    window.open(url, '_blank');
  }

  captuarLocalizacao() {
    this.jsonArrayGPS = [];
    this.jsonValidar = [];
    if (this.slideOneForm.invalid) {
      this.toastr.warning('VERIFIQUE OS CAMPOS OBRIGATÓRIOS!', 'Atenção!');
    } else {
      this.spinner.show();
      var params = this.slideOneForm.get('endereco').value + ',' + this.slideOneForm.get('numero').value + ',' + this.slideOneForm.get('cidade').value;
      this.apiService.getLocalizacao(params)
        .subscribe(
          (data) => { //start of (1)

            this.jsonArrayGPS = data;
            //console.log(this.jsonArrayGPS.results[0].geometry.location);
            this.latitude = this.jsonArrayGPS.results[0].geometry.location.lat;
            this.longetude = this.jsonArrayGPS.results[0].geometry.location.lng;

            this.slideOneForm.get('lat').setValue(this.latitude);
            this.slideOneForm.get('lng').setValue(this.longetude);

            //console.log(this.latitude);
            //console.log(this.longetude);

            /*if (this.validarCNPJ()) {
              this.salvarCadastro();
            } else {
              this.spinner.hide();
              this.toastr.warning('CNPJ INFORMADO NÃO É VÁLIDO!', 'Atenção!');
            }*/

            this.salvarCadastro();

          }, //end of (1)
          (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
          () => console.log('all data gets') //(3) second argument
        );
    }
  }

  validarCNPJ() {
    var cnpj = this.slideOneForm.get('cnpj').value;

    if (cnpj.length <= 0) {
      return true;
    } else {
      var cnpjvalidar = cnpj.split('-');
      // Esta função retira os caracteres . / - da string do cnpj, deixando apenas os números
      var strCNPJ = cnpj.replace('.', '').replace('.', '').replace('/', '').replace('-', '');

      if (cnpjvalidar[1] === '0') {
        strCNPJ = strCNPJ + '0';
      }

      // Verifica se a variável cnpj é igua a "undefined", exibindo uma msg de erro
      if (cnpj === undefined) {
        console.log('CNPJ INVÁLIDO');
        return false;
        // Testa as sequencias que possuem todos os dígitos iguais e se o cnpj não tem 14 dígitos, retonando falso e exibindo uma msg de erro
      } else if (strCNPJ === '00000000000000' || strCNPJ === '11111111111111' || strCNPJ === '22222222222222' || strCNPJ === '33333333333333' ||
        strCNPJ === '44444444444444' || strCNPJ === '55555555555555' || strCNPJ === '66666666666666' || strCNPJ === '77777777777777' ||
        strCNPJ === '88888888888888' || strCNPJ === '99999999999999' || strCNPJ.length !== 14) {
        console.log('CNPJ INVÁLIDO 1');
        return false;
      } else if (cnpjvalidar[1] === '00') {
        console.log('CNPJ VÁLIDO');
        return true;
      } else {
        // A variável numeros pega o bloco com os números sem o DV, a variavel digitos pega apenas os dois ultimos numeros (Digito Verificador).
        var tamanho = strCNPJ.length - 2;
        var numeros = strCNPJ.substring(0, tamanho);
        var digitos = strCNPJ.substring(tamanho);
        var soma = 0;
        var pos = tamanho - 7;

        // Os quatro blocos seguintes de funções irá reaizar a validação do CNPJ propriamente dito, conferindo se o DV bate. Caso alguma das funções não consiga verificar
        // o DV corretamente, mostrará uma mensagem de erro ao usuário e retornará falso, para que o usário posso digitar novamente um número
        for (let i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2) {
            pos = 9;
          }
        }

        var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0)) {
          console.log('CNPJ INVÁLIDO 2');
          return false;
        }

        tamanho = tamanho + 1;
        numeros = strCNPJ.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (let k = tamanho; k >= 1; k--) {
          soma += numeros.charAt(tamanho - k) * pos--;
          if (pos < 2) {
            pos = 9;
          }
        }

        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1)) {
          console.log('CNPJ INVÁLIDO 3');
          return false;
        }

        console.log('CNPJ VÁLIDO');
        return true;
      }
    }
  }

  salvarCadastro() {
    this.apiService.saveCadastro('atualziarcadastroapp', this.slideOneForm.value)
      .subscribe(
        (data) => { //start of (1)

          if (data) {
            this.modalRef.hide();
            localStorage.setItem('acesso', 'true');
            localStorage.setItem('lojistaid', data.toString());
            this.spinner.hide();
            this.toastr.success('CADASTRO ATUALIZADO!', 'Sucesso!');
            this.carregarLojista();
          } else {
            localStorage.setItem('acesso', 'false');
            localStorage.setItem('lojistaid', 'null');
            this.spinner.hide();
            this.toastr.warning('HOUVE UM ERRO AO VALIDAR OS DADOS, TENTE NOVAMENTE!', 'Atenção!');
          }

        }, //end of (1)
        (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

  filtrarCidades(uf) {
    this.jsonCidadeEstado = [];
    for (var i = 0; i < this.jsonArrayCidades.length; i++) {
      if (this.jsonArrayCidades[i].uf === uf) {
        this.jsonCidadeEstado.push({cidade: this.jsonArrayCidades[i].cidade});
      }
    }
  }

}
